import { createFileRoute } from '@tanstack/react-router';
// Route options read the light search module; the page is code-split with the component.
import { CalendarPage } from '@/features/calendar/pages/calendar-page';
import { CalendarSearchSchema } from '@/features/calendar/search';

/**
 * The Calendar app: the mini-month and the filters are in the list pane, the view is the main
 * pane. The view, the day, the filters and the open event are search params (see `search.ts`);
 * a reminder links to `?event=`.
 */
export const Route = createFileRoute('/_auth/o/$orgId/calendar')({
  validateSearch: (search) => CalendarSearchSchema.parse(search),
  component: CalendarRoute,
});

function CalendarRoute() {
  const { orgId } = Route.useParams();
  return <CalendarPage orgId={orgId} />;
}
